import { inject, observer } from "mobx-react";
import EditUserComponent from "../../components/UserManagement/EditUser/EditUserComponent.jsx";

const EditUser = inject('userStore','sharedStore')(observer(EditUserComponent));

export default EditUser;